class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[data-localization-form-input]')

    this.addEventListener('click', (e) => {
      if (!e.target.closest('a')) return;

      this.onItemClick(e);
    });
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.target.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
